module.exports = __webpack_public_path__ + "assets/c3f5c982f25ff20e1e69325f261e3f3c.png";